// ThemeRoutes.jsx
import { useRoutes } from 'react-router-dom';
import MainRoutes from './MainRoutes';
import PermissionRoutes from './PermissionRoutes';
import LoginRoutes from './LoginRoutes';
import ErrorRoutes from './ErrorRoutes';
import MainLayout from '../layouts/MainLayout/MainLayout';
import MinimalLayout from '../layouts/MinimalLayout/MinimalLayout';

export default function ThemeRoutes() {
  return useRoutes([
    {
      element: <MinimalLayout />, // for login and errors
      children: [
        ...LoginRoutes.children,
        ...ErrorRoutes.children,
      ]
    },
    {
      element: <MainLayout />, // all main & protected content
      children: [
        ...PermissionRoutes.children,
        ...MainRoutes.children,
      ]
    }
  ]);
}
